import { render, staticRenderFns } from "./editPageBlocks.vue?vue&type=template&id=71367df7&scoped=true&"
import script from "./editPageBlocks.vue?vue&type=script&lang=js&"
export * from "./editPageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./editPageBlocks.vue?vue&type=style&index=0&id=71367df7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71367df7",
  null
  
)

export default component.exports